import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerEditorCommand } from '../../browser/editorExtensions.js';
import { WordPartOperations } from '../../common/controller/cursorWordOperations.js';
import { Range } from '../../common/core/range.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { DeleteWordCommand, MoveWordCommand } from '../wordOperations/wordOperations.js';
import { CommandsRegistry } from '../../../platform/commands/common/commands.js';
export var DeleteWordPartLeft = /*#__PURE__*/function (_DeleteWordCommand) {
  _inherits(DeleteWordPartLeft, _DeleteWordCommand);

  var _super = _createSuper(DeleteWordPartLeft);

  function DeleteWordPartLeft() {
    _classCallCheck(this, DeleteWordPartLeft);

    return _super.call(this, {
      whitespaceHeuristics: true,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'deleteWordPartLeft',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 1
          /* Backspace */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(DeleteWordPartLeft, [{
    key: "_delete",
    value: function _delete(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      var r = WordPartOperations.deleteWordPartLeft(wordSeparators, model, selection, whitespaceHeuristics);

      if (r) {
        return r;
      }

      return new Range(1, 1, 1, 1);
    }
  }]);

  return DeleteWordPartLeft;
}(DeleteWordCommand);
export var DeleteWordPartRight = /*#__PURE__*/function (_DeleteWordCommand2) {
  _inherits(DeleteWordPartRight, _DeleteWordCommand2);

  var _super2 = _createSuper(DeleteWordPartRight);

  function DeleteWordPartRight() {
    _classCallCheck(this, DeleteWordPartRight);

    return _super2.call(this, {
      whitespaceHeuristics: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'deleteWordPartRight',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 20
          /* Delete */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(DeleteWordPartRight, [{
    key: "_delete",
    value: function _delete(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      var r = WordPartOperations.deleteWordPartRight(wordSeparators, model, selection, whitespaceHeuristics);

      if (r) {
        return r;
      }

      var lineCount = model.getLineCount();
      var maxColumn = model.getLineMaxColumn(lineCount);
      return new Range(lineCount, maxColumn, lineCount, maxColumn);
    }
  }]);

  return DeleteWordPartRight;
}(DeleteWordCommand);
export var WordPartLeftCommand = /*#__PURE__*/function (_MoveWordCommand) {
  _inherits(WordPartLeftCommand, _MoveWordCommand);

  var _super3 = _createSuper(WordPartLeftCommand);

  function WordPartLeftCommand() {
    _classCallCheck(this, WordPartLeftCommand);

    return _super3.apply(this, arguments);
  }

  _createClass(WordPartLeftCommand, [{
    key: "_move",
    value: function _move(wordSeparators, model, position, wordNavigationType) {
      return WordPartOperations.moveWordPartLeft(wordSeparators, model, position);
    }
  }]);

  return WordPartLeftCommand;
}(MoveWordCommand);
export var CursorWordPartLeft = /*#__PURE__*/function (_WordPartLeftCommand) {
  _inherits(CursorWordPartLeft, _WordPartLeftCommand);

  var _super4 = _createSuper(CursorWordPartLeft);

  function CursorWordPartLeft() {
    _classCallCheck(this, CursorWordPartLeft);

    return _super4.call(this, {
      inSelectionMode: false,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordPartLeft',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordPartLeft;
}(WordPartLeftCommand); // Register previous id for compatibility purposes

CommandsRegistry.registerCommandAlias('cursorWordPartStartLeft', 'cursorWordPartLeft');
export var CursorWordPartLeftSelect = /*#__PURE__*/function (_WordPartLeftCommand2) {
  _inherits(CursorWordPartLeftSelect, _WordPartLeftCommand2);

  var _super5 = _createSuper(CursorWordPartLeftSelect);

  function CursorWordPartLeftSelect() {
    _classCallCheck(this, CursorWordPartLeftSelect);

    return _super5.call(this, {
      inSelectionMode: true,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordPartLeftSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 1024
          /* Shift */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordPartLeftSelect;
}(WordPartLeftCommand); // Register previous id for compatibility purposes

CommandsRegistry.registerCommandAlias('cursorWordPartStartLeftSelect', 'cursorWordPartLeftSelect');
export var WordPartRightCommand = /*#__PURE__*/function (_MoveWordCommand2) {
  _inherits(WordPartRightCommand, _MoveWordCommand2);

  var _super6 = _createSuper(WordPartRightCommand);

  function WordPartRightCommand() {
    _classCallCheck(this, WordPartRightCommand);

    return _super6.apply(this, arguments);
  }

  _createClass(WordPartRightCommand, [{
    key: "_move",
    value: function _move(wordSeparators, model, position, wordNavigationType) {
      return WordPartOperations.moveWordPartRight(wordSeparators, model, position);
    }
  }]);

  return WordPartRightCommand;
}(MoveWordCommand);
export var CursorWordPartRight = /*#__PURE__*/function (_WordPartRightCommand) {
  _inherits(CursorWordPartRight, _WordPartRightCommand);

  var _super7 = _createSuper(CursorWordPartRight);

  function CursorWordPartRight() {
    _classCallCheck(this, CursorWordPartRight);

    return _super7.call(this, {
      inSelectionMode: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordPartRight',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordPartRight;
}(WordPartRightCommand);
export var CursorWordPartRightSelect = /*#__PURE__*/function (_WordPartRightCommand2) {
  _inherits(CursorWordPartRightSelect, _WordPartRightCommand2);

  var _super8 = _createSuper(CursorWordPartRightSelect);

  function CursorWordPartRightSelect() {
    _classCallCheck(this, CursorWordPartRightSelect);

    return _super8.call(this, {
      inSelectionMode: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordPartRightSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 512
          /* Alt */
          | 1024
          /* Shift */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordPartRightSelect;
}(WordPartRightCommand);
registerEditorCommand(new DeleteWordPartLeft());
registerEditorCommand(new DeleteWordPartRight());
registerEditorCommand(new CursorWordPartLeft());
registerEditorCommand(new CursorWordPartLeftSelect());
registerEditorCommand(new CursorWordPartRight());
registerEditorCommand(new CursorWordPartRightSelect());